"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductTypeEnum = exports.HospitalityTypeEnum = void 0;
function cov_i4av4m4p8() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/product/lib/constants.js";
  var hash = "882e25eb6fbf19ba1be33e066cf54f1c006abd04";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/product/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 31
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 35
        },
        end: {
          line: 26,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "882e25eb6fbf19ba1be33e066cf54f1c006abd04"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_i4av4m4p8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_i4av4m4p8();
var ProductTypeEnum = exports.ProductTypeEnum = (cov_i4av4m4p8().s[0]++, {
  SERVICE: 'SERVICE',
  VOUCHER: 'VOUCHER',
  DONATION: 'DONATION',
  GOODS: 'GOODS',
  PACKAGE: 'PACKAGE',
  EVENT: 'EVENT',
  VISIT: 'VISIT',
  TOUR: 'TOUR',
  PARKING: 'PARKING',
  SEASON_TICKET: 'SEASON_TICKET',
  SPORTING_EVENT: 'SPORTING_EVENT',
  MEMBERSHIP: 'MEMBERSHIP',
  TIMESLOT_PASS: 'TIMESLOT_PASS',
  VISIT_PASS: 'VISIT_PASS',
  PASS: 'PASS',
  OPEN_PASS: 'OPEN_PASS',
  HOSPITALITY: 'HOSPITALITY',
  HOSPITALITY_BUNDLE: 'HOSPITALITY_BUNDLE',
  UNKNOWN: 'UNKNOWN'
});
var HospitalityTypeEnum = exports.HospitalityTypeEnum = (cov_i4av4m4p8().s[1]++, {
  PRIVATE: 'PRIVATE',
  SHARED: 'SHARED'
});